import React from "react";

export default function ManagingOrganisationBanner({
  selectedConnection,
  platforms,
  getPlatformDisplayName
}) {
  if (!selectedConnection) return null;

  const logoColor = platforms.find(p => p.key === selectedConnection.platform)?.logoColor || '#6b7280';

  return (
    <div className="managing-org-banner d-flex align-items-center p-3 rounded mb-4 border bg-white shadow-sm gap-3 justify-content-between">
      <div className="d-flex align-items-center gap-3">
        <div
          className="platform-logo-circle d-flex align-items-center justify-content-center text-white font-weight-bold"
          style={{
            width: 40,
            height: 40,
            borderRadius: '50%',
            backgroundColor: logoColor,
            fontSize: '1rem'
          }}
        >
          {selectedConnection.platform?.charAt(0).toUpperCase()}
        </div>
        <div>
          <h4 className="font-weight-bold text-dark text-uppercase mb-1 text-start form-label-uppercase">
            Managing Organisation
          </h4>
          <div className="d-flex align-items-center gap-2 flex-wrap">
            <span className="font-weight-bold text-dark" style={{ fontSize: '1rem' }}>
              {selectedConnection.display_name}
            </span>
            <span>·</span>
            <span className="small">
              {getPlatformDisplayName(selectedConnection.platform)}
            </span>
            <span className="badge bg-warning text-dark small ms-1">Configuring</span>
          </div>
        </div>
      </div>
      {selectedConnection.updatedAt && (
        <div className="text-end">
          <p className="mb-0 small" style={{ fontSize: '0.75rem' }}>Last synced</p>
          <p className="font-weight-bold mb-0 small font-mono">
            {new Date(selectedConnection.updatedAt).toLocaleDateString()} {new Date(selectedConnection.updatedAt).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
          </p>
        </div>
      )}
    </div>
  );
}
